import { Grid } from "@mui/material";

import { SiTrackPage } from "../../components/si-track-page";
import { useState } from "react";
import { LeaveManageStatics } from "./leave-manage-statics.component";
import { LeaveManageComponent } from "./leave-manage-list.component";
import { LeaveRequest } from "../../models/leave-request";
import { SaveHookFormDialog } from "../../components/save-hook-form.dialog";
import { leaveManageApiKeyStore } from "../../api/leave-manage-api-key-store";
import { leaveRequestFormSchema } from "./create-leave/leave-request-form.schema";
import { LeaveRequestForm } from "./create-leave/leave-request.form";

export const ManageLeave = () => {

    const [editItem, setEditItem] = useState<Partial<LeaveRequest>>();
    const [value, setValue] = useState<string>("approval");

    const handleEditLeave = (leaveRequest: LeaveRequest) => {
        setEditItem(leaveRequest);
    };
    const handleEditClose = () => {
        setValue
        setEditItem(undefined);
    };
    const handleCreateLeave = (value: string) => {
        setValue(value);
        setEditItem({ leaveStatusID: 3 });
    };

    return (
        <SiTrackPage
            title="Manage Leave">
            <div>
                <Grid container spacing={2}>
                    <Grid item lg={12} sm={12} xl={12} xs={12}>
                        <LeaveManageStatics />
                    </Grid>
                    <Grid item lg={12} sm={12} xl={12} xs={12}>
                        <LeaveManageComponent dialogAction={handleCreateLeave} onEditLeave={handleEditLeave} />
                    </Grid>
                </Grid>
                {editItem && (
                    <SaveHookFormDialog
                        title={editItem.leaveID ? 'UPDATE LEAVE REQUEST' : 'APPLY FOR LEAVE'}
                        config={{
                            saveConfig: leaveManageApiKeyStore.applyLeave(),
                            invalidateRoute: () => value == "approval" ?
                                leaveManageApiKeyStore.getLeaveApprovalList({})
                                : leaveManageApiKeyStore.getLeaves(),
                        }}
                        data={editItem}
                        yupSchema={leaveRequestFormSchema}
                        onClose={handleEditClose}
                        size="lg"
                    >
                        <LeaveRequestForm />
                    </SaveHookFormDialog>
                )}
            </div>
        </SiTrackPage>
    );
}